import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
  createListingReviewRequest: ['listingId', 'payload'],
  createListingReviewSuccess: ['data'],
  createListingReviewFailure: ['error'],
  clearListingReview: null,
  fetchListingReviewsRequest: ['listingId', 'options'],
  fetchListingReviewsSuccess: ['data'],
  fetchListingReviewsFailure: ['error'],
})

export const ReviewsTypes = Types
export const ReviewsActions = Creators

const INITIAL_STATE = {
  creatingListingReview: false,
  createdListingReview: null,
  createListingReviewError: null,
  fetchingListingReviews: false,
  listingReviews: null,
  listingReviewsError: null,
}

const createListingReviewRequest = (state) => ({
  ...state,
  creatingListingReview: true,
  createdListingReview: null,
  createListingReviewError: null,
})

const createListingReviewSuccess = (state, action) => ({
  ...state,
  creatingListingReview: false,
  createdListingReview: action.data,
  createListingReviewError: null,
})

const createListingReviewFailure = (state, action) => ({
  ...state,
  creatingListingReview: false,
  createdListingReview: null,
  createListingReviewError: action.error,
})

const clearListingReview = (state) => ({
  ...state,
  createdListingReview: null,
  createListingReviewError: null,
})

const fetchListingReviewsRequest = (state) => ({
  ...state,
  fetchingListingReviews: true,
  listingReviewsError: null,
})

const fetchListingReviewsSuccess = (state, action) => ({
  ...state,
  fetchingListingReviews: false,
  listingReviews: action.data,
  listingReviewsError: null,
})

const fetchListingReviewsFailure = (state, action) => ({
  ...state,
  fetchingListingReviews: false,
  listingReviewsError: action.error,
})

export default createReducer(INITIAL_STATE, {
  [Types.CREATE_LISTING_REVIEW_REQUEST]: createListingReviewRequest,
  [Types.CREATE_LISTING_REVIEW_SUCCESS]: createListingReviewSuccess,
  [Types.CREATE_LISTING_REVIEW_FAILURE]: createListingReviewFailure,
  [Types.CLEAR_LISTING_REVIEW]: clearListingReview,
  [Types.FETCH_LISTING_REVIEWS_REQUEST]: fetchListingReviewsRequest,
  [Types.FETCH_LISTING_REVIEWS_SUCCESS]: fetchListingReviewsSuccess,
  [Types.FETCH_LISTING_REVIEWS_FAILURE]: fetchListingReviewsFailure,
})